import { ActionButton, Button, ChipStatus, Content, ContentHeader, FilterMenu, InputSearch, Paging, QueryState, QueryStateContent, Stack, Table, TableBody, TableCell, TableHead, TableRow } from 'src/app/components'
import dayjs from 'dayjs'
import CampaignScreens from '../../CampaignScreens'
import { AddRoundedIcon } from 'src/app/components/Icons'
import { usePermissions } from 'src/app/hooks/permissions-hook'
import { useSalesPromoHooks } from './SalesPromo.hooks'
import { SalesPromoModel } from '../../models/SalesPromo.model'
import { FilterMenuContentLuckyDraw } from './FilterMenuContentLuckyDraw/FilterMenuContentLuckyDraw.component'

export function SalesPromo() {

  const permission = usePermissions()
  const state = useSalesPromoHooks()

  const renderItem = (item: SalesPromoModel, index: number) => {
    return (
      <TableRow key={item.id}>
        <TableCell {...{ index }} />
        <TableCell value={item?.name} />
        <TableCell renderValue={(directories: SalesPromoModel['directories']) => {
          return (
            <div className="w-[145px]">
              {
                directories?.map((directory, index) => {
                  return (
                    <p key={directory.id} className='whitespace-pre-wrap inline'>
                      {directory.directory_name}
                      {index < directories.length - 1 && <span>, </span>}
                    </p>
                  )
                })
              }
            </div>
          )
        }}
          value={item?.directories}
        />
        <TableCell
          renderValue={(period: { start_date?: string, end_date?: string }) => {
            return (
              <>{(period.start_date && period.end_date) ? (
                <div>
                  {dayjs(period.start_date).format('DD/MM/YYYY')} - {dayjs(period.end_date).format('DD/MM/YYYY')}
                </div>
              ) : ('-')}
              </>)
          }}
          className="w-[145px]"
          value={{ start_date: item?.start_date, end_date: item?.end_date }}
        />
        <TableCell value={item?.is_direct_cashback_point} renderValue={(_) => _ ? 'Yes' : 'No'} />
        <TableCell value={item?.is_mission_collect_stamp} renderValue={(_) => _ ? 'Yes' : 'No'} />
        <TableCell>
          <ChipStatus state={item?.status} />
        </TableCell>
        <TableCell action={true}>
        {permission.setVisibleByAccess(
          ['manage_campaign_sales_promo.read'],
          <ActionButton
            className="mx-auto"
            variant="detail"
            to={CampaignScreens.DETAIL_SALES_PROMO.PATH.replace(':id', item.id!).replace(':path', 'detail')}
          />
        )}
        </TableCell>
      </TableRow>
    )
  }

  return (
    <Content>
      <ContentHeader title="List Sales Promotion">
        {permission.setVisibleByAccess(
          ['manage_campaign_sales_promo.create'],
          <Button
            startIcon={AddRoundedIcon}
            to={'/campaign/sales-promo/form/new'}
          >
            Add Sales Promotion
          </Button>,
        )}
      </ContentHeader>

      <Stack
        direction="row"
        justify="between"
        items="center"
        className="px-6 py-4"
      >
        <InputSearch />
        <FilterMenu>
          <FilterMenuContentLuckyDraw withCampaignType={false} withDirectCashbackPoint={true} withMissionCollectStamp={true} />
        </FilterMenu>
      </Stack>

      <QueryState query={state.salesPromoList}>
        <div className="px-8">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell index />
                <TableCell order='name'>Campaign Name</TableCell>
                <TableCell>Mall</TableCell>
                <TableCell order="start_date" className="w-[145px]">Period</TableCell>
                <TableCell order='is_direct_cashback_point'>Direct Cashback Point</TableCell>
                <TableCell order='is_mission_collect_stamp'>Mission Collect Stamp</TableCell>
                <TableCell>Status</TableCell>
                <TableCell action={true} className="w-[100px]" />
              </TableRow>
            </TableHead>
            <TableBody>
              {state.salesPromoList.data?.content?.map(renderItem)}
            </TableBody>
          </Table>
          <Paging query={state.salesPromoList} />
        </div>
        <QueryStateContent title="List Sales Promotion is Empty" />
      </QueryState>
    </Content>
  )
}
